"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAddedCommunicationMethods = exports.fillCommunicationMethod = exports.InitReports = exports.IkSnapHetNiet = exports.ReportsLoaded = void 0;
var Algemeen = require("./Algemeen");
var Aanvraag = require("./Aanvraag");
var $tableReports;
var CommunicationMethodsAll;
var Languages;
var ReportGroups;
var ReportDefinitions;
var ReportDecisions;
var ddlReportGroup;
var ddlReportDefinition;
var ddlCommunicationMethod;
var ddlToleranceCountry;
var tbAddress;
var ddlLanguage;
var ddlRetailer;
var $dialogReports;
var $dialogDuplicateReport;
var chkBio;
exports.ReportsLoaded = false;
function IkSnapHetNiet() {
    Aanvraag.Init();
}
exports.IkSnapHetNiet = IkSnapHetNiet;
function InitReports() {
    chkBio = $('#chkBio');
    chkBio.change(function () {
        debugger;
        BuildReportTable(CommunicationMethodsAll);
    });
    $tableReports = $('#tableReports');
    $dialogReports = $("#dialogReports");
    $dialogDuplicateReport = $('#dialogDuplicateReport');
    $dialogReports.dialog({
        autoOpen: false,
        modal: true,
        width: 500,
        title: Algemeen.Translate("nmWijzigen"),
        buttons: [
            {
                text: Algemeen.Translate('nmToevoegen'),
                click: function () {
                    if (Algemeen.validateEmail(tbAddress.val())) {
                        tbAddress.removeClass('ui-state-error');
                        ReportToevoegen();
                    }
                    else {
                        tbAddress.addClass('ui-state-error');
                        debugger;
                    }
                }
            },
            {
                text: Algemeen.Translate('nmAnnuleer'),
                click: function () { ReportAnnuleren(); }
            }
        ]
    });
    $dialogDuplicateReport.dialog({
        autoOpen: false,
        modal: true,
        width: 500,
        buttons: [
            {
                text: Algemeen.Translate('nmOk'),
                click: function () { $(this).dialog('close'); }
            }
        ]
    });
    Algemeen.CallWebServiceGetGeneric('GetLanguages', OnSuccessGetLanguages);
    Algemeen.CallWebServiceGetGeneric('GetReportGroups', OnSuccessGetReportGroups);
    Algemeen.CallWebServiceGetGeneric('GetReportDefinitions', OnSuccessGetReportDefinitions);
    Algemeen.CallWebServiceGetGeneric('GetReportDecisions', OnSuccessGetReportDecisions);
    InitDialogReports();
    ddlReportGroup = $('#ddlReportGroup');
    ddlReportDefinition = $('#ctl00_cphBody_ddlReportDefinition');
    ddlCommunicationMethod = $('#ctl00_cphBody_ddlCommunicationMethod');
    ddlToleranceCountry = $('#ctl00_cphBody_ddlToleranceCountry');
    tbAddress = $('#ctl00_cphBody_tbAddress');
    ddlLanguage = $('#ctl00_cphBody_ddlLanguage');
    ddlRetailer = $('#ctl00_cphBody_ddlRetailer');
    ddlReportGroup.change(function () { ddlReportGroupChanged(); });
    ddlReportDefinition.change(function () { ddlReportDefinitionChanged(); });
}
exports.InitReports = InitReports;
function fillCommunicationMethod(CommunicationMethods) {
    for (var i = 0; i < CommunicationMethods.length; i++) {
        var method = CommunicationMethods[i];
        if (!IsDuplicate(method)) {
            //AddCommunicationMethod(method, true);
            CommunicationMethodsAll.push(method);
        }
    }
    BuildReportTable(CommunicationMethodsAll);
    //Algemeen.SetRowBackcolor($tableReports);
}
exports.fillCommunicationMethod = fillCommunicationMethod;
function BuildReportTable(data) {
    CommunicationMethodsAll = data;
    $tableReports.find("tr:gt(0)").remove();
    for (var i = 0; i < CommunicationMethodsAll.length; i++) {
        if (CommunicationMethodsAll[i].ReportGroup == "R" && CommunicationMethodsAll[i].ReportType == "B" && CommunicationMethodsAll[i].TOLCOrganic) {
            if (chkBio.is(':checked')) {
                AddCommunicationMethod(CommunicationMethodsAll[i], false);
            }
        }
        else {
            AddCommunicationMethod(CommunicationMethodsAll[i], false);
        }
    }
    if (Aanvraag.EditMode) {
        for (var i = 0; i < Aanvraag.AanvraagObj.CommunicationMethods.length; i++) {
            var method = Aanvraag.AanvraagObj.CommunicationMethods[i];
            if (method.ReportGroup == "R" && method.ReportType == "B" && method.TOLCOrganic) {
                if (chkBio.is(':checked')) {
                    AddCommunicationMethod(method, true);
                }
            }
            else {
                AddCommunicationMethod(method, true);
            }
            //AddCommunicationMethod(Aanvraag.AanvraagObj.CommunicationMethods[i], true);
            if (!IsDuplicate(method))
                CommunicationMethodsAll.push(Aanvraag.AanvraagObj.CommunicationMethods[i]);
        }
    }
    Algemeen.SetRowBackcolor($tableReports);
    exports.ReportsLoaded = true;
    Aanvraag.CheckAllLoaded();
}
function OnSuccessGetDefaultCommunicationMethods(data, status) {
    Algemeen.CheckSessionTimeout(data);
    BuildReportTable(data.d);
}
function OnSuccessGetLanguages(data, status) {
    Algemeen.CheckSessionTimeout(data);
    Languages = data.d;
    Algemeen.CallWebServiceGetGeneric('GetDefaultCommunicationMethods', OnSuccessGetDefaultCommunicationMethods);
}
function OnSuccessGetReportGroups(data, status) {
    Algemeen.CheckSessionTimeout(data);
    ReportGroups = data.d;
}
function OnSuccessGetReportDefinitions(data, status) {
    Algemeen.CheckSessionTimeout(data);
    ReportDefinitions = data.d;
}
function OnSuccessGetReportDecisions(data, status) {
    Algemeen.CheckSessionTimeout(data);
    ReportDecisions = data.d;
}
function AddCommunicationMethod(CommunicationMethod, btnDelete) {
    var $tr = $('<tr class="trDefaultCommunicationMethod"></tr>');
    var $tdReportGroup = $('<td class="tdReportGroup"></td>');
    var $tdReportDefinitionName = $('<td class="tdReportDefinitionName"></td>');
    var $tdCommunicationMethod = $('<td class="tdCommunicationMethod"></td>');
    var $tdToleranceCountry = $('<td class="tdToleranceCountry"></td>');
    var $tdAddress = $('<td class="tdAddress"></td>');
    var $tdLanguage = $('<td class="tdLanguage"></td>');
    var $tdRetailer = $('<td class="tdRetailer"></td>');
    var $tdBtnEdit = $('<td class="tdLBtnEdit"></td>');
    $tdReportGroup.html(CommunicationMethod.ReportGroupDescription);
    $tdReportDefinitionName.html(CommunicationMethod.ReportDefinitionName);
    $tdCommunicationMethod.html(CommunicationMethod.CommunicationMethodDescription);
    $tdToleranceCountry.html(CommunicationMethod.ToleranceCountryDescription);
    $tdAddress.html(CommunicationMethod.Address);
    $tdLanguage.html(GetLanguageDescription(CommunicationMethod.Language));
    $tdRetailer.html(CommunicationMethod.RetailerDescription);
    var $btn;
    if (btnDelete) {
        $btn = $('<button type="button">' + Algemeen.Translate('nmVerwijder') + '</button>');
        $btn.click(function () { btnDeleteOnclick(this); });
    }
    else {
        $btn = $('<button type="button">' + Algemeen.Translate('nmAanpassen') + '</button>');
        $btn.click(function () { btnEditOnclick(CommunicationMethod); });
    }
    $btn.appendTo($tdBtnEdit);
    $tr.append($tdReportGroup).append($tdReportDefinitionName).append($tdCommunicationMethod).append($tdToleranceCountry).append($tdAddress).append($tdLanguage).append($tdRetailer).append($tdBtnEdit);
    $tableReports.append($tr);
}
function btnEditOnclick(CommunicationMethod) {
    //Check if communicationmethod present
    var reportGroupFound = false;
    for (var i = 0; i < ReportGroups.length; i++) {
        if (ReportGroups[i].Code == CommunicationMethod.ReportGroup)
            reportGroupFound = true;
    }
    if (reportGroupFound) {
        ddlReportGroup.val(CommunicationMethod.ReportGroup);
    }
    else {
        ddlReportGroup.val(ReportGroups[0].Code);
    }
    //ddlReportGroup.val(CommunicationMethod.ReportGroup);
    ddlReportDefinition.val(CommunicationMethod.ReportDefinition);
    ddlReportGroupChanged();
    ddlCommunicationMethod.val(CommunicationMethod.CommunicationMethod);
    ddlToleranceCountry.val(CommunicationMethod.ToleranceCountry);
    tbAddress.val(CommunicationMethod.Address);
    ddlLanguage.val(CommunicationMethod.Language);
    ddlRetailer.val(CommunicationMethod.RetailerId);
    showRetailer();
    $dialogReports.dialog("open");
}
function ddlReportDefinitionChanged() {
    showRetailer();
}
function ddlReportGroupChanged() {
    debugger;
    //Remember current definition
    var currentDefinition = ddlReportDefinition.val();
    Algemeen.clearDdl(ddlReportDefinition);
    for (var i = 0; i < ReportDecisions.length; i++) {
        if (ReportDecisions[i].Code == ddlReportGroup.val()) {
            for (var j = 0; j < ReportDefinitions.length; j++) {
                if (ReportDefinitions[j].Group == ReportDecisions[i].Description) {
                    if (currentDefinition == ReportDefinitions[j].Code)
                        Algemeen.AddItemASPDropdown(ddlReportDefinition, ReportDefinitions[j].Code, ReportDefinitions[j].Description, true);
                    else
                        Algemeen.AddItemASPDropdown(ddlReportDefinition, ReportDefinitions[j].Code, ReportDefinitions[j].Description, false);
                }
            }
        }
    }
    //Check current defintion still valid
}
function showRetailer() {
    if (Algemeen.getItemDescription(ReportDefinitions, ddlReportDefinition.val()) == 'A') {
        $('.divRetailer').show();
    }
    else {
        $('.divRetailer').hide();
        ddlRetailer.val('');
    }
}
function btnDeleteOnclick(btn) {
    var tr = $(btn).closest('.trDefaultCommunicationMethod');
    tr.css("background-color", "#FF3700");
    tr.fadeOut(400, function () {
        CommunicationMethodsAll.splice((tr.prevAll().length - 1), 1);
        tr.remove();
        Algemeen.SetRowBackcolor($tableReports);
    });
}
function ReportToevoegen() {
    var CommunicationMethod = new CCommunicationMethod();
    CommunicationMethod.ReportGroup = 'R';
    CommunicationMethod.ReportGroupDescription = Algemeen.getItemDescription(ReportGroups, 'R');
    CommunicationMethod.ReportDefinition = ddlReportDefinition.val();
    CommunicationMethod.ReportDefinitionName = ddlReportDefinition.find('option:selected').text();
    //CommunicationMethod.ReportType;
    CommunicationMethod.CommunicationMethod = ddlCommunicationMethod.val();
    CommunicationMethod.CommunicationMethodDescription = ddlCommunicationMethod.find('option:selected').text();
    CommunicationMethod.ToleranceCountry = ddlToleranceCountry.val();
    CommunicationMethod.ToleranceCountryDescription = ddlToleranceCountry.find('option:selected').text();
    CommunicationMethod.Address = tbAddress.val();
    CommunicationMethod.Language = ddlLanguage.val();
    if ($('.divRetailer').is(":visible")) {
        CommunicationMethod.RetailerId = ddlRetailer.val();
        CommunicationMethod.RetailerDescription = ddlRetailer.find('option:selected').text();
    }
    else {
        CommunicationMethod.RetailerId = '';
        CommunicationMethod.RetailerDescription = '';
    }
    CommunicationMethod.Added = true;
    if (IsDuplicate(CommunicationMethod)) {
        $dialogDuplicateReport.dialog("open");
    }
    else {
        CommunicationMethodsAll.push(CommunicationMethod);
        AddCommunicationMethod(CommunicationMethod, true);
        Algemeen.SetRowBackcolor($tableReports);
        $dialogReports.dialog("close");
    }
}
function IsDuplicate(CommunicationMethod) {
    for (var i = 0; i < CommunicationMethodsAll.length; i++) {
        if ((CommunicationMethod.ReportGroup == CommunicationMethodsAll[i].ReportGroup) &&
            (CommunicationMethod.ReportDefinition == CommunicationMethodsAll[i].ReportDefinition) &&
            (CommunicationMethod.CommunicationMethod == CommunicationMethodsAll[i].CommunicationMethod) &&
            (CommunicationMethod.ToleranceCountry == CommunicationMethodsAll[i].ToleranceCountry) &&
            (CommunicationMethod.Address == CommunicationMethodsAll[i].Address) &&
            (CommunicationMethod.Language == CommunicationMethodsAll[i].Language) &&
            (CommunicationMethod.RetailerId == CommunicationMethodsAll[i].RetailerId)) {
            return true;
        }
    }
    return false;
}
function ReportAnnuleren() {
    $dialogReports.dialog("close");
}
function InitDialogReports() {
}
function GetLanguageDescription(code) {
    for (var i = 0; i < Languages.length; i++) {
        if (Languages[i].Code == code) {
            return Languages[i].Description;
        }
    }
    return '';
}
//function ValidateReports() {
//    return true;
//}
function CCommunicationMethod() {
    this.ReportGroup;
    this.ReportGroupDescription;
    this.ReportDefinition;
    this.ReportDefinitionName;
    this.ReportType;
    this.CommunicationMethod;
    this.CommunicationMethodDescription;
    this.ToleranceCountry;
    this.ToleranceCountryDescription;
    this.Address;
    this.Language;
    this.RetailerId;
    this.RetailerDescription;
    this.Added;
}
function GetAddedCommunicationMethods() {
    var CommunicationMethods = [];
    for (var i = 0; i < CommunicationMethodsAll.length; i++) {
        if (CommunicationMethodsAll[i].Added) {
            CommunicationMethods.push(CommunicationMethodsAll[i]);
        }
    }
    return CommunicationMethods;
}
exports.GetAddedCommunicationMethods = GetAddedCommunicationMethods;
